export const isDamHorseProfile = () => document.querySelector('.ui-icon.ui-icon_sizeDam') !== null;



// WEBPACK FOOTER //
// ./src/js/utils/isDamHorseProfile.js